export default {
  schedule: {
    type: Object,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/schedulings/components/transfer/resources/props.js